import isEqual from 'lodash/isEqual';

import type { ChangeProposalCompareTask } from '../../data-contract/chat';

const ordered = (tasks: readonly ChangeProposalCompareTask[]): readonly ChangeProposalCompareTask[] =>
    tasks.every((task) => typeof task.order === 'number')
        ? [...tasks].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        : tasks;

export const compareTaskContents = (
    left: readonly ChangeProposalCompareTask[],
    right: readonly ChangeProposalCompareTask[],
) =>
    (
        [
            { side: 'removed', current: left, other: right },
            { side: 'added', current: right, other: left },
        ] as const
    ).map(({ side, current, other }) => {
        const counterparts = ordered(other);
        const consumed = new Set<number>();
        return {
            side,
            tasks: ordered(current).map((task) => {
                const index = counterparts.findIndex(
                    (candidate, candidateIndex) =>
                        !consumed.has(candidateIndex) &&
                        (task.id
                            ? candidate.id === task.id
                            : task.key
                              ? candidate.key === task.key
                              : candidate.title === task.title),
                );
                if (index !== -1) consumed.add(index);
                return { task, other: index === -1 ? undefined : counterparts[index] };
            }),
        };
    });

export const isWorkflowStepChanged = (
    task: ChangeProposalCompareTask,
    other: ChangeProposalCompareTask | undefined,
    index: number,
): boolean => !isEqual(task.workflow?.steps[index], other?.workflow?.steps[index]);
